<template>
    <v-content>
        <v-app-bar color="#F8F8F8" class="mx-4" height="70" elevate-on-scroll scroll-target="#scrolling-techniques-7">
            <v-row class="d-flex align-center justify-start">
                <v-col class="d-flex align-center" cols="5">
                    <v-icon class="mr-3" color="#111111">fa-gift</v-icon>
                    <p class="mb-n1" v-html="$t('doYouHaveCoupon')"></p>
                    <v-text-field :label="$t('coupon')" v-model="couponName" class="mx-12 mt-6" v-on:keyup.enter="getPlansByCoupon" outlined/>
                </v-col>
                <v-col cols="5"></v-col>
                <v-col class="text-right" cols="2">
                    <v-btn style="color: #ffffff !important; background-color: #111111 !important;" @click="getPlansByCoupon">{{ $t('claimCoupon') }}</v-btn>
                </v-col>
            </v-row>
        </v-app-bar>
        <v-divider></v-divider>
        <v-container fluid>
            <v-row>
                <v-col cols="3">
                  <v-row align="center" justify="start" style="height: 70vh;">
                    <div>
                      <v-chip color="secondary" small>
                        <p class="my-0" style="font-size: 14px;"> PRO
                          <v-icon class="mt-n1" color="accent" x-small>fa-star</v-icon>
                        </p>
                      </v-chip>
                      <h1 class="my-5">{{ $t('ctaTitle') }}</h1>
                      <h2>{{ $t('ctaSubtitle') }}</h2>
                    </div>
                  </v-row>
                </v-col>
                <PlanCard :coupon-name="couponNameValidated" :key="'plan'+i" v-for="(info, i) in plans" :information="info" :properties="properties" @payNow="payNow" @successfulPayment="successfulPayment" :highlighted="highlight == undefined ? true : info.planName.toLowerCase().startsWith(highlight.toLowerCase())"/>
            </v-row>
        </v-container>

        <v-container fluid>
            <v-row align="center" justify="center">
                <v-btn class="my-2" @click="keepFreePlan" plain> {{ $t('keepFreePlan') }} </v-btn>
            </v-row>
        </v-container>

        <!--dialog!-->
        <v-dialog v-model="dialog" max-width="500">
            <v-card outlined>
                <v-card-title class="py-5 headline grey lighten-2 justify-center">
                    <h3>{{ dialogTitle }}</h3>
                </v-card-title>
                <v-card-text class="my-5 text-center justify-center">
                    <p>{{ dialogMessage }}</p>
                    <v-btn @click="dialog = false"> Ok </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-overlay :value="checkoutDialog">
            <Checkout :plan="planToCheckout" @cancelPayment="cancelPayment" @successfulPayment="successfulPayment" @errorOnPayment="errorOnPayment"/>
        </v-overlay>
    </v-content>
</template>

<script>
    import PricingPlans from './pricingPlans';
    import PlanCard from "./PlanCard";
    import SubscriptionRepository from '../../repositories/subscription';
    import Checkout from "./Checkout";

    export default {
        name: "SubscriptionPlans",
        components: {
            Checkout,
            PlanCard
        },
        props: {
            highlight: String,
        },
        data(){
            return {
                //plans: this.$store.state.plans.information,
                plans: PricingPlans.information,
                //properties: this.$store.state.plans.properties,
                properties: PricingPlans.properties.en,
                paypalButtonSize: 'Small',
                paypalButtonShape: 'pill',
                confirmationInfo: {
                    titleMessage: this.$t('confirmationInfo.titleMessage'),
                    bodyMessage: this.$t('confirmationInfo.bodyMessage'),
                    goToMessage: this.$t('confirmationInfo.goToMessage'),
                    afterConfirmationRoute: 'dashboard',
                },
                dialog: false,
                dialogTitle: '',
                dialogMessage: '',
                couponName: '',
                couponNameValidated: '',

                // Checkout
                planToCheckout: null,
                checkoutDialog: false,
            }
        },
        watch: {
            '$i18n.locale': function(){
                this.refreshPricingPlans();
            }
        },
        created(){
            this.validateAuthenticated();
        },
        mounted(){
            window.fbq('track', 'InitiateCheckout');
            const script = document.createElement("script");
            script.src = this.$store.state.paypalSubscriptionsScript;
            script.addEventListener("load", this.renderPaypalButtons);
            document.body.appendChild(script);
            let referred = this.$store.state.user.details.referredFrom;
            if(referred !== null){
                this.getPlansByReferred(referred);
            }
            this.refreshPricingPlans();
        },
        methods:{
            refreshPricingPlans(){
                this.properties = (this.$i18n.locale === "en")? PricingPlans.properties.en : PricingPlans.properties.es;
            },
            payNow(plan) {
                this.planToCheckout = plan;
                this.checkoutDialog = true;
            },
            validateAuthenticated() {
                if(this.$store.state.token === '')
                    this.$router.push('/');
            },
            getPlansByCoupon(){
                if (this.couponName.length > 0) {
                    SubscriptionRepository.getPlansByCoupon(this.couponName).then((response) => {
                        if (response.status < 400) {
                            if (typeof response.data == 'string') {
                                this.dialogTitle = this.$t('somethingWentWrong');
                                this.dialogMessage = response.data;
                                this.dialog = true;
                            } else {
                                this.setNewPlansInformation(response);
                            }
                        }
                    });
                } else
                    alert(this.$t('couponNameIsRequired'));
            },
            getPlansByReferred(referredFrom) {
                SubscriptionRepository.getReferredPlans(referredFrom).then((response) => {
                    if(response.status < 400) {
                        if (typeof response.data == 'string') {
                            this.dialogTitle = this.$t('somethingWentWrong');
                            this.dialogMessage = response.data;
                            this.dialog = true;
                        } else {
                            this.setNewPlansInformation(response);
                        }
                    }
                });
            },
            setNewPlansInformation(info) {
                this.couponNameValidated = this.couponName;
                let plans = info.data;
                let oldPlans = this.plans;
                this.plans = [];
                this.plans[oldPlans.length - 1] = {
                    planName: oldPlans[oldPlans.length - 1].planName,
                    planId: oldPlans[oldPlans.length - 1].planId,
                    currency: oldPlans[oldPlans.length - 1].currency,
                    periodicity: oldPlans[oldPlans.length - 1].periodicity,
                    billed: oldPlans[oldPlans.length - 1].billed,
                    price: oldPlans[oldPlans.length - 1].price,
                    color: oldPlans[oldPlans.length - 1].color
                };
                plans = this.orderPlansByPeriodicity(plans);
                plans.forEach((item, index) => {
                    this.plans[index] = {
                        planName: item.name,
                        planId: item.planId,
                        currency: oldPlans[index].currency,
                        periodicity: oldPlans[index].periodicity,
                        billed: oldPlans[index].billed,
                        price: item.price,
                        color: oldPlans[index].color
                    };
                });
            },
            orderPlansByPeriodicity(plans) {
                let periods = ['Monthly', 'Annually'];
                let aux = [];
                for(let i = 0; i < periods.length; i++){
                    let getOut = false;
                    for (let j = 0; j < plans.length && !getOut; j++) {
                        if (plans[j].name.startsWith(periods[i])) {
                            getOut = true;
                            aux.push(plans[j]);
                        }
                    }
                }
                return aux;
            },
            renderPaypalButtons(){
                var elements = document.querySelectorAll('.paypal-button-container');
                for(let i = 0; i < elements.length; i++) {
                    if(this.plans[i].planName.includes('Lifetime')) {
                        window.paypal.Buttons({
                            style: {
                                size: this.paypalButtonSize,
                                color: this.plans[i].color,
                                shape: this.paypalButtonShape,
                            },
                            createOrder: (data, actions) => {
                                return actions.order.create({
                                    purchase_units: [
                                    {
                                        amount: {
                                        currency_code: "USD",
                                        value: this.plans[i].price.toString()
                                        }
                                    }]
                                });
                            },
                            onApprove: async (data, actions) => {
                                return actions.order.capture().then((details) => {
                                    let subInfo = {
                                        user_id: this.userId,
                                        subscription_id: data.orderID,
                                        plan_id: this.plans[i].planId
                                    };
                                    if(details.status === 'COMPLETED') {
                                        SubscriptionRepository.lifetimeSubscriptionCompleted(subInfo).then((response) => {
                                            if(response.status < 400){
                                                window.fbq('track', 'Purchase');
                                                this.$router.push({
                                                    name: 'confirmation',
                                                    params: { titleMessage: this.confirmationInfo.titleMessage,
                                                        bodyMessage: this.confirmationInfo.bodyMessage,
                                                        goToMessage: this.confirmationInfo.goToMessage,
                                                        afterConfirmationRoute: this.confirmationInfo.afterConfirmationRoute}
                                                });
                                            }
                                        });
                                    }
                                });
                            },
                            onError: () => {
                                this.dialogTitle = this.$t('somethingWentWrong');
                                this.dialogMessage = this.$t('errorTryingToConnect');
                                this.dialog = true;
                            }
                        }).render(elements[i]);
                    } else {
                        window.paypal.Buttons({
                            style: {
                                size: this.paypalButtonSize,
                                color: this.plans[i].color,
                                shape: this.paypalButtonShape,
                            },
                            createSubscription: (data, actions) => {
                                return actions.subscription.create({
                                    'plan_id': this.plans[i].planId
                                });
                            },
                            onApprove: async (data) => {
                                let subInfo = {
                                    user_id: this.$store.state.user.id,
                                    subscription_id: data.subscriptionID,
                                    plan_id: this.plans[i].planId
                                };
                                SubscriptionRepository.subscriptionApproved(subInfo).then((response) => {
                                    if(response.status < 400){
                                        window.fbq('track', 'Purchase');
                                        this.$router.push({
                                            name: 'confirmation',
                                            params: { titleMessage: this.confirmationInfo.titleMessage,
                                                bodyMessage: this.confirmationInfo.bodyMessage,
                                                goToMessage: this.confirmationInfo.goToMessage,
                                                afterConfirmationRoute: this.confirmationInfo.afterConfirmationRoute}
                                        });
                                    }
                                })
                            },
                            onError: () => {
                                this.dialogTitle = this.$t('somethingWentWrong');
                                this.dialogMessage = this.$t('errorTryingToConnect');
                                this.dialog = true;
                            }
                        }).render(elements[i]);
                    }
                }
            },
            successfulPayment() {
                this.checkoutDialog = false;
                window.fbq('track', 'Purchase');
                this.$router.push({
                    name: 'confirmation',
                    params: { titleMessage: this.confirmationInfo.titleMessage,
                        bodyMessage: this.confirmationInfo.bodyMessage,
                        goToMessage: this.confirmationInfo.goToMessage,
                        afterConfirmationRoute: this.confirmationInfo.afterConfirmationRoute}
                });
            },
            errorOnPayment() {
                this.checkoutDialog = false;
                this.dialogTitle = this.$t('somethingWentWrong');
                this.dialogMessage = this.$t('errorTryingToConnect');
                this.dialog = true;
            },
            cancelPayment() {
                this.checkoutDialog = false;
            },
            keepFreePlan() {
                this.$router.push('/dashboard');
            }
        },
    }
</script>

<style scoped>

</style>

<i18n>
{
    "en":{
        "doYouHaveCoupon": "<b>Do you have a coupon?</b> Claim it here!",
        "coupon": "Coupon",
        "claimCoupon": "Claim Coupon",
        "somethingWentWrong": "Something went wrong",
        "errorTryingToConnect": "Error when trying to connect with PayPal / ePayco. Please try again later.",
        "couponNameIsRequired": "Coupon name is required",

        "ctaTitle": "Swiset Pro is the most powerful and versatile suite",
        "ctaSubtitle": "And will cost you less than one stop, a prop trading test and more. It's your moment!",

        "keepFreePlan": "I want to continue with the free plan.",

        "confirmationInfo":{
            "titleMessage": "Payment created",
            "bodyMessage": "Once PayPal / ePayco / DePay confirms that the transaction was successful, you will get all the benefits of Pro Plan.",
            "goToMessage": "Go to Dashboard"
        }
    },
    "es":{
        "doYouHaveCoupon": "<b>¿Tienes un cupón?</b> ¡Reclámalo aquí!",
        "coupon": "Cupón",
        "claimCoupon": "Reclamar cupón",
        "somethingWentWrong": "Ha habido un error",
        "errorTryingToConnect": "Error al conectarse con PayPal / ePayco. Por favor intenta mas tarde.",
        "couponNameIsRequired": "El nombre del cupón es requerido",

        "ctaTitle": "Swiset Pro es la suite más potente y versátil",
        "ctaSubtitle": "Y te cuesta menos que un stop, que una prueba de fondeo y más ¡Es tú momento!",

        "keepFreePlan": "Quiero continuar con el plan gratuito.",

        "confirmationInfo":{
            "titleMessage": "Pago creado",
            "bodyMessage": "Una vez PayPal / ePayco / DePay confirme que la transacción fue exitosa, obtendras todos los beneficios del plan Pro.",
            "goToMessage": "Ir al Dashboard"
        }
    }
}
</i18n>
